( function( $, document, window ) {
	'use strict';

	$( function() {
		const swiper = new Swiper('.js-hero-carousel', {
			autoplay: true,
			direction: 'horizontal',
			effect: 'fade',
			slidesPerView: 1,
			pagination: {
				el: ".js-hero-carousel-pagination",
				clickable: true,
				type: 'bullets',
				renderBullet: function (index, className) {
					const slide = this.slides[index];
					const label = slide?.dataset.label ?? '';
					const count = (index + 1).toString().padStart(2, '0');

					return `<span class="hero-carousel-pagination__item  ${className}"><span class="hero-carousel-pagination__count">${count}.</span> ${label}</span>`;
				},
			},

			on: {
				init() {
					scrollActiveBullet(this);
					animateActiveBullet(this);
				},
				slideChangeTransitionEnd() {
					scrollActiveBullet(this);
					animateActiveBullet(this);
				},

				// slideChange: function () {
				// 	// scroll active bullet into view
				// 	const pagination = document.querySelector('.js-hero-carousel-pagination');
				// 	const activeBullet = pagination.querySelector('.swiper-pagination-bullet-active');
				// 	if (activeBullet) {
				// 		activeBullet.scrollIntoView({
				// 			behavior: 'smooth',
				// 			inline: 'center',   // scroll horizontally to center active bullet
				// 			block: 'nearest'
				// 		});
				// 	}
				// }
			}
		});


		function scrollActiveBullet(swiper) {
			const pagination = swiper.pagination.el;
			if (!pagination) return;

			const activeBullet = pagination.querySelector('.swiper-pagination-bullet-active');
			if (!activeBullet) return;

			const containerWidth = pagination.offsetWidth;
			const bulletLeft = activeBullet.offsetLeft;
			const bulletWidth = activeBullet.offsetWidth;

			const scrollPos = bulletLeft - (containerWidth / 2) + (bulletWidth / 2);

			pagination.scrollTo({
				left: scrollPos,
				behavior: 'smooth'
			});
		}

		// Animate bullet lines
		// Note: cannot use default swiper active class as this shows line at 100% on initial load
		function animateActiveBullet(swiper) {
			// Remove is-active from all bullets
			const bullets = swiper.pagination.el.querySelectorAll('.hero-carousel-pagination__item');
			bullets.forEach(b => b.classList.remove('is-active'));

			// Add is-active class to the active bullet
			const active = swiper.pagination.el.querySelector('.swiper-pagination-bullet-active');
			if (active) {
				// Force reflow to ensure CSS transition runs
				void active.offsetWidth;
				active.classList.add('is-active');
			}
		}
	} );
} )( jQuery, document, window );
